import { render, staticRenderFns } from "./Description.vue?vue&type=template&id=90fb243c&"
import script from "./Description.vue?vue&type=script&lang=js&"
export * from "./Description.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90fb243c')) {
      api.createRecord('90fb243c', component.options)
    } else {
      api.reload('90fb243c', component.options)
    }
    module.hot.accept("./Description.vue?vue&type=template&id=90fb243c&", function () {
      api.rerender('90fb243c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/SPFPlayer/lib/Description.vue"
export default component.exports